import * as React from 'react'
function SvgIndicatorWarning(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34.432 30.058L21.764 6.308c-.752-1.412-2.776-1.412-3.53 0L5.568 30.058C4.858 31.39 5.824 33 7.334 33h25.334c1.508 0 2.474-1.61 1.764-2.942zM20 29a2 2 0 11.001-4.001A2 2 0 0120 29zm2-6h-4v-8h4v8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgIndicatorWarning
